import $ from 'jquery';
import { Autoplay, Navigation, Swiper } from 'swiper';

import { $Elements, BrowserEvents, TransitionDurations, Classes, BrowserEvents as StripeCardEvents } from './constants';
import bootbox from 'bootbox';

Swiper.use([Autoplay, Navigation]);

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Modal Add to cart ----------

	$Elements.body.on('adding_to_cart', function(e, button, cart) {

		$Elements.LoadingBar.addClass(Classes.loading);

		$Elements.body.one('added_to_cart', () => {

			$Elements.LoadingBar.removeClass(Classes.loading);

			if(typeof added_to_cart_modal !== 'undefined') {

				bootbox.dialog({
					centerVertical: true,
					className: 'cart-modal',
					closeButton: false,
					message: added_to_cart_modal.content,
				});
			}

			if(cart.length) {
				const quantity = cart.find(item => item.name === 'quantity');

				if(quantity) {
					const link = $('.shop-links #header-cart-count');
					const current = parseInt(link.text());
					link.text(current + parseInt(quantity.value));
				}
			}
		});
	});

	// ---------- Shipping calculator ----------

	const shippingCalculator = $('#shipping-calculator-modal');

	if(shippingCalculator.length) {
		shippingCalculator.modal();
	}

	// ---------- Stripe ----------

	const stripeCard = $('#wc-cpsw_stripe-payment-token-new');

	if(stripeCard.length) {

		$Elements.window.on('load', function() {
			stripeCard.trigger('click');
		});
	}
});
